export default __webpack_public_path__ + "static/media/amex_promo_background.853aa9a5.svg";